module.exports = __webpack_public_path__ + "img/member3.f7b8488.jpg";